export default __webpack_public_path__ + "static/media/snow.2b1bdec9.mp4";